import React, { useEffect, useRef, useState } from "react";
import style from "css/telehealth.module.css";
import { Link } from "react-router-dom";
import Questions from "components/app/questions";
import { openPopup } from "redux/slices/drawerPopupSlice";
import { useDispatch } from "react-redux";
import NeatPopup from "components/device/neat/neatPopup";

function Teleconsolution() {
  //dispatch
  const dispatch = useDispatch();
  const [body, setBody] = useState(1);
  const [info, setInfo] = useState(1);

  const infoBodyList = [
    {
      header: "글로벌 협업 및 접근성 향상",
      img: "img/smartspace/consolution6.png",
      body1:
        "스마트 텔레헬스 협진 시스템은 Zoom Video를 통해 고해상도 화상 협진을 지원합니다.",
      body2: (
        <font>
          이는 장소와 시간에 구애받지 않고 의료진이 원활하게 협력할 수 있도록
          도와줍니다.
          <br /> 최고 수준의 음질과 화질을 보장하여 끊김 없는 영상 중심 협진이
          가능하며,
          <br /> 참여자들은 간편하게 회의에 참여할 수 있습니다. 대기실 기능을
          통해 강화된 <br />
          접근 보안을 제공하며, 모든 참가자의 발언과 의견을 명확하게 전달합니다.
        </font>
      ),
    },
    {
      header: "글로벌 협업 및 접근성 향상2",
      img: "img/smartspace/consolution6.png",
      body1:
        "스마트 텔레헬스 협진 시스템은 Zoom Video를 통해 고해상도 화상 협진을 지원합니다.",
      body2: (
        <font>
          이는 장소와 시간에 구애받지 않고 의료진이 원활하게 협력할 수 있도록
          도와줍니다.
          <br /> 최고 수준의 음질과 화질을 보장하여 끊김 없는 영상 중심 협진이
          가능하며,
          <br /> 참여자들은 간편하게 회의에 참여할 수 있습니다. 대기실 기능을
          통해 강화된 <br />
          접근 보안을 제공하며, 모든 참가자의 발언과 의견을 명확하게 전달합니다.
        </font>
      ),
    },
    {
      header: "글로벌 협업 및 접근성 향상3",
      img: "img/smartspace/consolution6.png",
      body1:
        "스마트 텔레헬스 협진 시스템은 Zoom Video를 통해 고해상도 화상 협진을 지원합니다.",
      body2: (
        <font>
          이는 장소와 시간에 구애받지 않고 의료진이 원활하게 협력할 수 있도록
          도와줍니다.
          <br /> 최고 수준의 음질과 화질을 보장하여 끊김 없는 영상 중심 협진이
          가능하며,
          <br /> 참여자들은 간편하게 회의에 참여할 수 있습니다. 대기실 기능을
          통해 강화된 <br />
          접근 보안을 제공하며, 모든 참가자의 발언과 의견을 명확하게 전달합니다.
        </font>
      ),
    },
  ];

  const [infoBody, setInfoBody] = useState(infoBodyList[0]);
  useEffect(() => {
    setInfoBody(infoBodyList[info - 1]);
  }, [info]);

  const scrollContainerRef = useRef(null);

  const handleMouseDown = (e) => {
    const container = scrollContainerRef.current;
    container.isDown = true;
    container.startX = e.pageX - container.offsetLeft;
    container.scrollLeft = container.scrollLeft;
  };

  const handleMouseLeave = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseUp = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseMove = (e) => {
    const container = scrollContainerRef.current;
    if (!container.isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - container.startX) * 0.5; // 스크롤 속도 조절
    container.scrollLeft = container.scrollLeft - walk;
  };

  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      원격진료 시스템 <font>구성 환경</font>
    </div>
  );

  const Compose = [
    {
      id: 1,
      img: "img/smartspace/composeImg1.png",
      title: "스마트 워크 플랫폼 all Place",
      txt: "all Place는 회의실/자율좌석 예약 및 관리 플랫폼입니다.\n 사용자가 PC나 모바일을 통해 쉽게 예약할 수 있게 해주며, \n예얀된 내용을 회의실 디스플레이 장비와 실시간으로 동기화됩니다.",
      linkonClick: () => showDrawer("allplace"),
    },
    {
      id: 2,
      img: "img/smartspace/composeImg1.png",
      title: "neat. frame",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },
    {
      id: 3,
      img: "img/smartspace/composeImg1.png",
      title: "neat. frame",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },
    {
      id: 4,
      img: "img/smartspace/composeImg1.png",
      title: "neat. frame",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };

  return (
    <>
      <NeatPopup />
      <div className={style.wrapper}>
        <div className={style.healthTitle}>
          <p>Teleconsultation System</p>
          <p>원격 협진 시스템</p>
          <p>
            리브테크놀로지의 협진 플랫폼은 All in One 솔루션으로, 통합된 기능과
            확장성을 제공합니다. <br />이 플랫폼은 원격 진료 · 협진 · 의료
            세미나 등의 다양한 기능을 하나의 시스템에 통합하여, 의료진과 환자가
            하나의 플랫폼에서 모든 진료 활동을 효율적으로 관리할 수 있게 합니다.{" "}
            <br />
            이를 통해 의료 서비스의 품질을 높이고, 진료의 연속성과 효율성을
            극대화할 수 있습니다.
          </p>
        </div>
        <div className={style.healthImg}>
          <img
            alt=""
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/roundingImg1.png"
            }
          />
        </div>

        <div className={style.consolutionBody}>
          <div className={style.consolutionWrap}>
            <div className={style.consolutionBodyTitle}>
              <p>
                리브테크놀로지의 <font> 스마트 텔레헬스 협진 시스템</font>은
                다양한 기능들을 통합하여,
              </p>
              <p>
                의료진에게 <font>최적의 협진 환경을 제공</font>합니다.
              </p>
              <p>
                구성 환경은 공간과 목적에 따라 맞추형으로 조정 및 변경이
                가능합니다.
              </p>
            </div>
            <div className={style.consolutionBodyInfo}>
              <div className={style.consolutionBodyInfoWrap1}>
                <div>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/zoomLogo.png"
                    }
                  />
                </div>
                <div className={style.consolutionInfoBtnList}>
                  <div
                    className={body === 1 ? style.bodyOn : style.bodyOff}
                    onClick={() => setBody(1)}
                  >
                    <p>
                      <font>01</font>
                      <font>화상 협진</font>
                    </p>
                    <p>Video</p>
                  </div>
                  <div
                    className={body === 2 ? style.bodyOn : style.bodyOff}
                    onClick={() => setBody(2)}
                  >
                    <p>
                      <font>02</font>
                      <font>상시 소통</font>
                    </p>
                    <p>Chat</p>
                  </div>
                  <div
                    className={body === 3 ? style.bodyOn : style.bodyOff}
                    onClick={() => setBody(3)}
                  >
                    <p>
                      <font>03</font>
                      <font>응급 소통</font>
                    </p>
                    <p>Phone</p>
                  </div>
                  <div
                    className={body === 4 ? style.bodyOn : style.bodyOff}
                    onClick={() => setBody(4)}
                  >
                    <p>
                      <font>04</font>
                      <font>맞춤형 협진 플랫폼 구축</font>
                    </p>
                    <p></p>
                  </div>
                </div>
              </div>
              <div className={style.consolutionBodyInfoWrap2}>
                <div>
                  <font>0{body} / </font>
                  <font>04</font>
                </div>
                <div>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/consolution2.png"
                    }
                  />
                </div>
                <div>
                  스마트 텔레헬스 협진 시스템은 화상회의 플랫폼을 통해 고해상도
                  화상 협진을 지원합니다. 이는 장소와 시간에 구애받지 않고
                  의료진이 원활하게 협력할 수 있도록 도와줍니다. 최고 수준의
                  음질과 화질을 보장하여 끊김 없는 영상 중심 협진이 가능하며,
                  참여자들은 간편하게 회의에 참여할 수 있습니다.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={style.healthBody2}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/teleBackgroundImg.png')",
          }}
        >
          <div className={style.consolutionInfo}>
            <div className={style.consolutionInfoHeader}>
              <font>리브테크놀로지의 Telehealth</font>
              <font>원격협진 시스템</font>
            </div>
            <div className={style.consolutionInfoTypeList}>
              <div
                onClick={() => {
                  setInfo(1);
                }}
                className={info === 1 ? style.infoOn : style.infoOff}
              >
                {" "}
                글로벌 협업 및 <br /> 접근성 향상
              </div>
              <div
                className={info === 2 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(2);
                }}
              >
                팀 기반 <br /> 협진 시스템 전략
              </div>
              <div
                className={info === 3 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(3);
                }}
              >
                개인 간<br /> 협진 시스템 전략
              </div>
            </div>
            <div className={style.consolutionInfoBody}>
              <div>
                <img
                  alt=""
                  src={`${process.env.REACT_APP_CLIENT_URL}` + infoBody.img}
                />
              </div>
              <div>
                <font>{infoBody.header}</font>
                <font>{infoBody.body1}</font>
                {infoBody.body2}
              </div>
            </div>
          </div>
        </div>
        <div className={style.commonCompose}>
          <div className={style.commonCompseBody}>
            {ComposeHeader}
            <div
              className={style.commonComposeCardWrap}
              ref={scrollContainerRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              {Compose.map((info) => (
                <div className={style.commonComposeCard}>
                  <div className={style.commonComposeCardImg}>
                    <p>
                      <font>{info.id}</font> / {Compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    <Link
                      to={`${process.env.REACT_APP_CLIENT_URL + info.link}`}
                    >
                      <div>
                        <font>More</font>{" "}
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/arrowRight.png"
                          }
                        />
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
            <div className={style.commonComposeFooter}>
              <div
                style={{
                  backgroundImage:
                    "url('" +
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/composefooterImg.png')",
                }}
              >
                <p>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/bang.png"
                    }
                  />
                </p>
                <p>
                  <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다. 상담을
                  통해 정확히 진단해 보세요.
                </p>
              </div>
            </div>
          </div>
          <div className={style.commonComposeFooter}>
            <div
              style={{
                backgroundImage:
                  "url('" +
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/composefooterImg.png')",
              }}
            >
              <p>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/bang.png"
                  }
                />
              </p>
              <p>
                <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다. 상담을
                통해 정확히 진단해 보세요.
              </p>
            </div>
          </div>
        </div>
        <Questions />
      </div>
    </>
  );
}

export default Teleconsolution;
